'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('ipld-dag-pb'),
    DAGLink = _require.DAGLink,
    DAGNode = _require.DAGNode;

var UnixFS = require('ipfs-unixfs');

var Dir = require('./dir');

var persist = require('./utils/persist');

var DirFlat = /*#__PURE__*/function (_Dir) {
  _inherits(DirFlat, _Dir);

  var _super = _createSuper(DirFlat);

  function DirFlat(props, options) {
    var _this2;

    _classCallCheck(this, DirFlat);

    _this2 = _super.call(this, props, options);
    _this2._children = {};
    return _this2;
  }

  _createClass(DirFlat, [{
    key: "put",
    value: function put(name, value) {
      this.cid = undefined;
      this.size = undefined;
      this._children[name] = value;
    }
  }, {
    key: "get",
    value: function get(name) {
      return this._children[name];
    }
  }, {
    key: "childCount",
    value: function childCount() {
      return Object.keys(this._children).length;
    }
  }, {
    key: "directChildrenCount",
    value: function directChildrenCount() {
      return this.childCount();
    }
  }, {
    key: "onlyChild",
    value: function onlyChild() {
      return this._children[Object.keys(this._children)[0]];
    }
  }, {
    key: "eachChildSeries",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function eachChildSeries() {
      var keys, i, key;
      return _regeneratorRuntime.wrap(function eachChildSeries$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              keys = Object.keys(this._children);
              i = 0;

            case 2:
              if (!(i < keys.length)) {
                _context.next = 9;
                break;
              }

              key = keys[i];
              _context.next = 6;
              return {
                key: key,
                child: this._children[key]
              };

            case 6:
              i++;
              _context.next = 2;
              break;

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, eachChildSeries, this);
    })
  }, {
    key: "flush",
    value: function flush(path, block) {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var children, links, i, child, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, entry, unixfs, node, buffer, cid, size;

        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                children = Object.keys(_this._children);
                links = [];
                i = 0;

              case 3:
                if (!(i < children.length)) {
                  _context2.next = 45;
                  break;
                }

                child = _this._children[children[i]];

                if (!(typeof child.flush === 'function')) {
                  _context2.next = 41;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context2.prev = 8;
                _iterator = _asyncIterator(child.flush(child.path, block));

              case 10:
                _context2.next = 12;
                return _awaitAsyncGenerator(_iterator.next());

              case 12:
                _step = _context2.sent;
                _iteratorNormalCompletion = _step.done;
                _context2.next = 16;
                return _awaitAsyncGenerator(_step.value);

              case 16:
                _value = _context2.sent;

                if (_iteratorNormalCompletion) {
                  _context2.next = 25;
                  break;
                }

                entry = _value;
                child = entry;
                _context2.next = 22;
                return child;

              case 22:
                _iteratorNormalCompletion = true;
                _context2.next = 10;
                break;

              case 25:
                _context2.next = 31;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 31:
                _context2.prev = 31;
                _context2.prev = 32;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context2.next = 36;
                  break;
                }

                _context2.next = 36;
                return _awaitAsyncGenerator(_iterator.return());

              case 36:
                _context2.prev = 36;

                if (!_didIteratorError) {
                  _context2.next = 39;
                  break;
                }

                throw _iteratorError;

              case 39:
                return _context2.finish(36);

              case 40:
                return _context2.finish(31);

              case 41:
                links.push(new DAGLink(children[i], child.size, child.cid));

              case 42:
                i++;
                _context2.next = 3;
                break;

              case 45:
                unixfs = new UnixFS({
                  type: 'directory',
                  mtime: _this.mtime,
                  mode: _this.mode
                });
                node = new DAGNode(unixfs.marshal(), links);
                buffer = node.serialize();
                _context2.next = 50;
                return _awaitAsyncGenerator(persist(buffer, block, _this.options));

              case 50:
                cid = _context2.sent;
                size = buffer.length + node.Links.reduce(function (acc, curr) {
                  return acc + curr.Tsize;
                }, 0);
                _this.cid = cid;
                _this.size = size;
                _context2.next = 56;
                return {
                  cid: cid,
                  unixfs: unixfs,
                  path: path,
                  size: size
                };

              case 56:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, null, [[8, 27, 31, 41], [32,, 36, 40]]);
      }))();
    }
  }]);

  return DirFlat;
}(Dir);

module.exports = DirFlat;